import React, { Component } from 'react';

class Success extends Component {
  render() {
    return (
      <div className="status-outline">
        <div className="usa-alert usa-alert-success">
          <div className="usa-alert-body">
            <h3 className="usa-alert-heading">Login Succeeded</h3>
            <p className="usa-alert-text">
              You are now logged in.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Success;



// WEBPACK FOOTER //
// ./src/Success.jsx